import React, { useEffect, useState, forwardRef } from "react";
import { Input } from "antd";

const InputFrom3 = forwardRef((props, ref) => {
  const { value, defaultValue, onChange, ...rest } =
    props;

  const isControlled = value !== undefined;

  const [internalValue, setInternalValue] = useState(defaultValue || "");

  const currentValue = isControlled ? value : internalValue;

  useEffect(() => {
    if (!isControlled) {
      setInternalValue(defaultValue || "");
    }
  }, [defaultValue, isControlled]);

  const handleChange = (e) => {
    const val = e.target.value;

    if (!isControlled) {
      setInternalValue(val);
    }

    onChange?.(e);
  };

  return (
    <Input
      ref={ref}
      value={currentValue}
      onChange={handleChange}
      {...rest}
    />
  );
});

export default InputFrom3;
